import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { trackingAPI } from '@/lib/api';
import { hasTrackingConsent } from '@/components/CookieConsent';

export default function QRRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const track = async () => {
      if (hasTrackingConsent()) {
        try {
          await trackingAPI.trackQRScan({
            source: 'qrcode',
            traffic_source: 'qr',
            utm_source: searchParams.get('utm_source'),
            utm_medium: searchParams.get('utm_medium'),
            utm_campaign: searchParams.get('utm_campaign'),
            referrer: document.referrer,
            browser: navigator.userAgent,
            device: /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
            os: navigator.platform,
          });
        } catch (err) {
          console.error('QR tracking failed:', err);
        }
      }
      navigate('/', { replace: true });
    };
    track();
  }, [navigate, searchParams]);

  return (
    <div data-testid="qr-redirect-page" className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0E518D] mx-auto mb-4" />
        <p className="text-slate-600 font-body text-sm">Weiterleitung...</p>
      </div>
    </div>
  );
}
